// agent唯一标识
export enum AgentUnionCode {
    /**
     * 技术问答
     */
    eureka_rd_ai_agent_technical_qa = 'eureka_rd_ai_agent_technical_qa', // seek

    /**
     * 生物医药——原研药查询
     */
    eureka_ls_agent_innovator_drug_quick_search = 'eureka_ls_agent_innovator_drug_quick_search',

    /**
     * 生物医药——PCC
     */
    eureka_ls_agent_patent_preclinical_candidate_compound = 'eureka_ls_agent_patent_preclinical_candidate_compound',

    /**
     * 生物医药——PK/PD数据分析
     */
    eureka_ls_agent_patent_pk_pd = 'eureka_ls_agent_patent_pk_pd',

    /**
     * 生物医药——立项报告
     */
    eureka_ls_agent_initiate_project = 'eureka_ls_agent_initiate_project',

      /**
     * 监控技术简报
     */
    eureka_pt_ai_agent_create_tech_monitor = 'eureka_pt_ai_agent_create_tech_monitor',

    /**
     * 监控公司技术简报
     */
    eureka_pt_ai_agent_create_company_tech_monitor = 'eureka_pt_ai_agent_create_company_tech_monitor',

    /**
     * 生物医药-sar提取
     */
    eureka_ls_agent_sar = 'eureka_ls_agent_sar',

    /**
     * LCA agent.
     */
    eureka_ls_agent_lca = 'lca-agent-pre-alpha-stream'
}
